module.exports = "<section id=landing-page transition=home _v-ef3167ac=\"\"><div id=home _v-ef3167ac=\"\"><h1 _v-ef3167ac=\"\">{{title}}</h1><p class=home-copy _v-ef3167ac=\"\">{{copy}}</p><a v-link=\"{ path: '/targets' }\" class=home-link _v-ef3167ac=\"\">DISCOVER HDR</a></div><div id=home-bg v-bind:style=\"{ backgroundImage: 'url(' + background + ')' }\" _v-ef3167ac=\"\"></div></section>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-ef3167ac!./~/vue-loader/lib/template-loader.js?raw&engine=jade!./~/vue-loader/lib/selector.js?type=template&index=0!./public/_src/_vue/Home.vue
 ** module id = 43
 ** module chunks = 0
 **/